'use client';

import { Popover, PopoverContent } from '@/components/ui/popover';
import { PopoverAnchor } from '@radix-ui/react-popover';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Combobox } from '@/components/utils/combobox';
import { useRouter } from 'next/navigation';
import { fetchAvailableFiltersRequest } from '@/utils/filter-request';
import SearchModal from '../search-modal';

export default function MainSearchInput({
    hideCity,
    city,
    onSelectCity,
    className,
    placeHolder,
}: {
    hideCity?: boolean;
    city?: string;
    onSelectCity?: (city?: string) => void;
    className?: string;
    placeHolder?: string;
}) { 
    
    return (
        <SearchModal
            hideSearchIcon
            hideCity={hideCity}
            placeHolder={placeHolder}
            inputClassName={`${
                className ? className : ''
            } border text-black border-neutral-200 placeholder:!text-[#999999] rounded-xl py-2`}
        />
    );
}
